import { render, staticRenderFns } from "./JumpInfo.vue?vue&type=template&id=89052088&scoped=true"
import script from "./JumpInfo.vue?vue&type=script&lang=js"
export * from "./JumpInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89052088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89052088')) {
      api.createRecord('89052088', component.options)
    } else {
      api.reload('89052088', component.options)
    }
    module.hot.accept("./JumpInfo.vue?vue&type=template&id=89052088&scoped=true", function () {
      api.rerender('89052088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/JumpInfo.vue"
export default component.exports